import React from 'react';

const ClientLogos = () => {
  // --- IMPORTANT ---
  // Replace these with the actual paths to your client logo images.
  // For best results, use transparent .png or .svg files with similar dimensions.
  const logos = [
    { name: 'Client A', src: '/assets/brazil.jpg' },
    { name: 'Client B', src: '/assets/microsoft.jpg' },
    { name: 'Client C', src: '/assets/kenyaair.jpg' },
    { name: 'Client D', src: '/assets/old mutual.jpg' },
    { name: 'Client E', src: '/assets/showmax.jpg' },
    { name: 'Client F', src: '/assets/media.png' },
  ];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="text-center">
          <h2 className="font-heading text-3xl font-bold text-foreground mb-4">
            Trusted by Leading Brands & Happy Couples
          </h2>
          <p className="font-body text-lg text-muted-foreground max-w-2xl mx-auto mb-12">
            We are proud to have partnered with a diverse range of clients to bring their visions to life.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
          {logos.map((logo) => (
            <div key={logo.name} className="flex justify-center">
              <img
                src={logo.src}
                alt={logo.name}
                className="h-12 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ClientLogos;